import { createI18n, useI18n } from "vue-i18n";

import en from "../../lang/en.json";
import fr from "../../lang/fr.json";

export const messages = {
    en,
    fr,
};

export const i18n = createI18n({
    locale: window.otomatic_ai?.default_locale, // set locale
    fallbackLocale: "en", // set fallback locale
    messages, // set locale messages
    legacy: false,
});
